var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentFavlistInfluencers.includes(_vm.influencerId))?_c('button-with-icon',{attrs:{"title":_vm.$t('common.button.remove-from-favlist'),"icon":`${_vm.$publicPath}img/favorite-remove.png`,"version":"white"},on:{"click":_vm.removeFromFavlist}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }